import { render, staticRenderFns } from "./select-team.vue?vue&type=template&id=6dd7781d&scoped=true&"
import script from "./select-team.vue?vue&type=script&lang=js&"
export * from "./select-team.vue?vue&type=script&lang=js&"
import style0 from "./select-team.vue?vue&type=style&index=0&id=6dd7781d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd7781d",
  null
  
)

export default component.exports